import { AssetLoader } from '@mews/framework';
import { PaymentCardImageTypes } from '@mews/framework/payments';

export enum PaymentMethodImageType {
    Ideal = 'ideal',
    PaymentCard = 'card',
    ApplePay = 'applePay',
    GooglePay = 'googlePay',
    SepaDirectDebit = 'sepa',
    PayPal = 'paypal',
}

export interface PaymentMethodImageTypeProps {
    className?: string;
    type: PaymentMethodImageType | keyof PaymentCardImageTypes;
    assetLoader?: AssetLoader;
    small?: boolean;
}
